import React from 'react'

const Button = ({ children, className, disabled, onClick }) => {
    return (
        <button className={`button ${className}`} disabled={disabled ? true : false} onClick={disabled ? null : onClick}>
            <span>{children}</span>
        </button>
    )
}

export default Button
